const dictionary = {
  en: {
    messages: {
      required: () =>
        "This is a mandatory field, please do not leave it empty.",
      email: () =>
        "Email is invalid. It should contain @ followed by a domain.",
      min: (value, param) =>
        `${value} is invalid. It should have minimum of ${param} characters.`,
      max: (value, param) => `This field only allows ${param} characters.`,
      alpha: () => "This field can only contain alphabets.",
      alpha_num: () => "This field can only contain alphabets and number.",
      numeric: () => "This field can only contain number.",
      digits: (value, param) => `This field only allows ${param} characters.`
    }
  }
};

export default dictionary;
